import { Trans } from "@lingui/react/macro"
import { Button, Text } from "@mantine/core"

import type { IProps } from "./interfaces"
import classes from "./styles.module.css"

export const ViewingAsBannerView = ({ companyName, onExit, exiting = false }: IProps): React.JSX.Element => {
  return (
    <div className={classes.banner} role="status">
      <Text className={classes.copy} component="p" size="sm">
        <Trans>
          Viewing <strong>{companyName}</strong> as super-admin. Changes here apply to {companyName}.
        </Trans>
      </Text>
      <Button className={classes.exit} size="xs" variant="filled" color="warning" loading={exiting} onClick={onExit}>
        <Trans>Exit</Trans>
      </Button>
    </div>
  )
}
